import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface FloatingSparklesProps {
  count?: number;
  color?: string;
  className?: string;
}
export function FloatingSparkles({
  count = 20,
  color = '#D4849A',
  className = ''
}: FloatingSparklesProps) {
  const [sparkles, setSparkles] = useState<Array<{
    id: number;
    x: number;
    y: number;
    size: number;
    delay: number;
    duration: number;
    type: 'diamond' | 'star' | 'circle';
  }>>([]);
  useEffect(() => {
    const newSparkles = Array.from({
      length: count
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 10 + 5,
      delay: Math.random() * 5,
      duration: Math.random() * 4 + 4,
      type: Math.random() > 0.6 ? 'diamond' : Math.random() > 0.5 ? 'star' : 'circle'
    }));
    setSparkles(newSparkles as any);
  }, [count]);
  return <div className={`absolute inset-0 pointer-events-none overflow-hidden z-0 ${className}`} data-id="element-144">
      {sparkles.map(sparkle => <motion.div key={sparkle.id} className="absolute" initial={{
      opacity: 0,
      left: `${sparkle.x}%`,
      top: `${sparkle.y + 20}%`,
      scale: 0
    }} animate={{
      opacity: [0, 0.8, 0],
      top: [`${sparkle.y + 20}%`, `${sparkle.y - 20}%`],
      scale: [0, 1, 0],
      rotate: sparkle.type === 'diamond' ? [0, 180] : 0
    }} transition={{
      duration: sparkle.duration,
      repeat: Infinity,
      delay: sparkle.delay,
      ease: 'linear'
    }} style={{
      color: color
    }} data-id="element-145">
          {sparkle.type === 'diamond' && <svg viewBox="0 0 100 100" style={{
        width: sparkle.size * 1.5,
        height: sparkle.size * 1.5
      }} className="drop-shadow-[0_0_3px_rgba(212,132,154,0.5)]" data-id="element-146">
              <defs data-id="element-147">
                <linearGradient id={`fGrad${sparkle.id}`} x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-148">
                  <stop offset="0%" stopColor="#F5E0E8" data-id="element-149" />
                  <stop offset="50%" stopColor={color} data-id="element-150" />
                  <stop offset="100%" stopColor="#A06080" data-id="element-151" />
                </linearGradient>
              </defs>
              <polygon points="50,5 90,35 75,90 25,90 10,35" fill={`url(#fGrad${sparkle.id})`} stroke={color} strokeWidth="1.5" data-id="element-152" />
              <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-153" />
              <polygon points="50,35 75,90 25,90" fill="#FFF5F8" fillOpacity="0.3" data-id="element-154" />
              <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-155" />
            </svg>}
          {sparkle.type === 'star' && '✦'}
          {sparkle.type === 'circle' && <div className="rounded-full" style={{
        width: sparkle.size / 2,
        height: sparkle.size / 2,
        backgroundColor: color,
        boxShadow: `0 0 ${sparkle.size}px ${color}`
      }} data-id="element-156" />}
        </motion.div>)}
    </div>;
}